/**
 * Inicializa los carruseles basados en Swiper.
 *
 * Swiper ya venia cargado por CDN en layout/theme.liquid pero no se usaba: los
 * carruseles iban con el slider nativo de Dawn (scroll-snap + scrollTo), que no
 * puede reproducir dos cosas de shop.scania.com:
 *   - slidesPerView fraccionario (4.1 / 3.02), el "peek" de la siguiente tarjeta
 *   - freeMode, el arrastre libre sin encajar en pasos
 *
 * Cada carrusel declara su configuracion en data-swiper-config (JSON). Los
 * valores salen medidos de la referencia; ver los comentarios de cada seccion.
 */
(function () {
  'use strict';

  var INSTANCES = new WeakMap();

  function init(root) {
    if (typeof window.Swiper === 'undefined') return;

    var nodes = (root || document).querySelectorAll('[data-swiper-config]');

    Array.prototype.forEach.call(nodes, function (el) {
      if (INSTANCES.has(el)) return;

      var config;
      try {
        config = JSON.parse(el.getAttribute('data-swiper-config'));
      } catch (e) {
        console.warn('swiper-carousel: data-swiper-config no es JSON valido', el, e);
        return;
      }

      // Nada de selectores globales: con varios carruseles en la pagina,
      // '.swiper-button-next' haria que uno controlase a otro. Se busca primero
      // dentro del contenedor y, si no aparece, en el ambito de la seccion,
      // porque las flechas de la home viven en la fila del titulo (un hermano
      // anterior al .swiper). Hay un solo carrusel por seccion.
      if (config.navigation) {
        var scope = el.closest('.shopify-section') || el.parentElement || document;
        config.navigation.nextEl = el.querySelector('.swiper-button-next') || scope.querySelector('.swiper-button-next');
        config.navigation.prevEl = el.querySelector('.swiper-button-prev') || scope.querySelector('.swiper-button-prev');
        if (!config.navigation.nextEl || !config.navigation.prevEl) delete config.navigation;
      }
      if (config.pagination) {
        config.pagination.el = el.querySelector('.swiper-pagination');
        if (!config.pagination.el) delete config.pagination;
      }

      // freeMode cambio de forma entre Swiper 6 y 8: en 8 es un objeto.
      if (config.freeMode === true) config.freeMode = { enabled: true };

      INSTANCES.set(el, new window.Swiper(el, config));
    });
  }

  function destroy(root) {
    var nodes = (root || document).querySelectorAll('[data-swiper-config]');
    Array.prototype.forEach.call(nodes, function (el) {
      var instance = INSTANCES.get(el);
      if (instance) {
        instance.destroy(true, true);
        INSTANCES.delete(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Editor de temas: las secciones se re-renderizan y hay que re-inicializar.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) { destroy(e.target); });
})();
